export function getUrlParamValue(param, urlSearchParams = window.location.search) {
  const urlParams = new URLSearchParams(urlSearchParams);
  return urlParams.get(param);
}
export function removeUrlParams(param, url = window.location.href) {
  const path = new URL(url);
  const urlParams = path.searchParams;
  urlParams.delete(param);
  path.search = urlParams.toString();
  return path.toString();
}